import { memo, useEffect, useRef } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { Editor, EditorInstance } from '@shared/components/Editor'
import { LoadingIndicator, NotFound } from '@shared/layouts'
import { useMediaAssetUpdateMutation } from 'hooks/mutations/media/MediaAsset'
import { mediaPlatformAssetRawRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Assets/Asset'
import { mediaAssetQueryKeys } from 'services/queryKeys/media'

const JSONRaw = () => {
  const { t } = useTranslation(['common', 'domain'])
  const { enqueueSnackbar } = useSnackbar()

  const editorInstanceRef = useRef<EditorInstance>(undefined)

  const { assetId } = mediaPlatformAssetRawRoute.useParams()

  const assetQuery = useQuery(mediaAssetQueryKeys.detail({ assetId }))
  const { data: asset } = assetQuery

  const { mutate } = useMediaAssetUpdateMutation()

  useEffect(() => {
    if (editorInstanceRef.current && assetQuery.isSuccess) {
      editorInstanceRef.current.getModel()?.setValue(window.JSON.stringify(asset, null, 4))
    }
  }, [assetQuery, asset])

  if (assetQuery.isLoading) {
    return <LoadingIndicator />
  }

  if (!asset) {
    return <NotFound />
  }

  return (
    <Editor
      value={asset}
      onSubmit={(data) => {
        mutate(
          {
            assetId,
            mediaAssetEdit: data,
          },
          {
            onSuccess: () => {
              enqueueSnackbar(t('saved'), {
                variant: 'success',
              })
            },
          },
        )
      }}
      getEditorInstance={(editorInstance: EditorInstance) => void (editorInstanceRef.current = editorInstance)}
    />
  )
}

export const JSON = memo(JSONRaw)
